var _rect, _circle, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDvla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#00AFEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 48,
    height: 32,
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 32,
    r: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 26,
    x2: 50,
    y2: 26
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 32,
    x2: 50,
    y2: 32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 38,
    x2: 44,
    y2: 38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvla);
export default __webpack_public_path__ + "static/media/DVLA.80460efd74616a88b65bdc9cd9c496c6.svg";
export { ForwardRef as ReactComponent };